<template>
  <div>
    <form-wizard 
      color="#7367F0" :title="null" :subtitle="null" 
      layout="horinzotal" finish-button-text="Actualizar"
      back-button-text="Retroceder" next-button-text="Siguiente" 
      @click.prevent="validationForm"
      class="wizard-vertical mb-4" 
      @on-complete="formSubmittedUpdateDoctor" 
      @before-change="beforeStepChange"
    >
      <!-- información general del doctor -->
      <tab-content title="Información del doctor." :before-change="validationFormInfo">
        <validation-observer ref="infoRules" tag="form">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Información del doctor.
              </h5>
              <small class="text-muted">
                Ingresa la información del doctor.
              </small>
            </b-col>
            
            <b-col md="6">
              <b-form-group label-for="v-name">
                <label>Nombres: <span class="text-danger">*</span></label>
                <validation-provider #default="{ errors }" name="nombre" rules="required">
                  <b-form-input id="v-name" :state="errors.length > 0 ? false : null" v-model="nombred" type="text"
                    placeholder="Escriba su nombre" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-lastname">
                <label>Apellidos: <span class="text-danger">*</span></label>
                <validation-provider #default="{ errors }" name="apellido" rules="required">
                  <b-form-input id="v-lastname" :state="errors.length > 0 ? false : null" v-model="apellidod" type="text"
                    placeholder="Escriba su apellido" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">

              <b-form-group label-for="v-datebirth">
                <label>Fecha de nacimiento: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }"  name="fechaNacimiento" rules="required">
                  <div class="flatpickr-container">
                    <flat-pickr v-model="fechaNacimiento" :state="errors.length > 0 ? false : null" locale="es" :config="birthDateConfig">
                    </flat-pickr>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-fechainicio">
                <label>Fecha de ingreso: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }"  name="fechaInicioDoctor" rules="required">
                  <div class="flatpickr-container">
                    <flat-pickr id="v-fechainicio" v-model="fechaInicioDoctor"  :state="errors.length > 0 ? false : null" locale="es" :config="birthDateConfig">
                    </flat-pickr>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label-for="v-tipo-ident">
                <label>Tipo Identificación: <span class="text-danger">*</span></label>
                <validation-provider 
                  v-slot="{ errors }" 
                  name="tipoIdent" 
                  rules="required"
                >
                  <b-form-select
                    id="v-type-ident"
                    v-model="tipoIdent"
                    :options="opsTipoIdent"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="mc-identificacion">
                <label>Identificación: <span class="text-danger">*</span></label>
                <validation-provider 
                  #default="{ errors }"
                  name="identificacion" 
                  :rules="identificacionRules"
                >
                  <b-form-input
                    id="mc-identificacion"
                    v-model="identificacion"
                    placeholder="0999999999"
                    name="identificacion"
                    type="text"
                    :maxlength="maxInputLength"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-cell">
                <label>Celular: <span class="text-danger">*</span></label>
                <b-form-input 
                  id="v-cell" type="text" placeholder="099999999" v-model="celular"
                  maxlength="10" pattern="[0-9]{10}" title="Ingresa un número de celular válido" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="mc-email"
              >
                <label>Correo eletrónico: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Correo eletrónico"
                  rules="required|email"
                >
                  <b-form-input
                    id="mc-email"
                    v-model="email"
                    placeholder="ana@example.com"
                    name="email"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-reg-senn">
              <label>Número de registro de Sennecyt: <span class="text-danger">*</span></label>                  <validation-provider #default="{ errors }" name="numeroregistrosenescypt" rules="required">
                  <b-form-input id="v-reg-senn" :state="errors.length > 0 ? false : null" type="text" placeholder="5465-4654-64654" v-model="numeroregistrosenescyt" maxlength="80"
                    pattern="[0-14]{15}" title="Ingresa número de registro Sennecyt" />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-tipodoctor">
                <label>Tipo de Doctor: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="tipodoctor" rules="required">
                  <v-select 
                    id="v-tipodoctor" 
                    v-model="tipodoctor" 
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                    :options="opsTipoDoctor"
                    label="text"
                    value="value" 
                    :class="{ 'is-invalid': errors.length > 0 }" />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group  label-for="v-especialidad">
                <label>Especialidad: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="especialidad" rules="required">
                  <v-select 
                    id="v-especialidad" 
                    v-model="especialidad" 
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                    :options="opsEspecialidad"
                    label="text"
                    value="value"
                    :class="{ 'is-invalid': errors.length > 0 }"  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <tab-content title="Horario" :before-change="validationHorario">
        <DoctorHorarioForm v-model="horariosDoctor" :turno.sync="turnoMinutos" />
      </tab-content>
      <!-- documentos -->
      <tab-content title="Documentos" :before-change="validationFormDocu">
        <validation-observer ref="docuRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Documentos</h5>
              <small class="text-muted">Agregar los documentos necesarios</small>
            </b-col>
          </b-row>
          <b-row>

            <b-card class="col-12" style="border: 1px solid #c9c9c9">

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Titulo</h6>

                <b-link
                  v-if="urlTituloDoc" 
                  class="text-primary col-2"
                  @click="onViewFile(urlTituloDoc)"
                  :disabled="!urlTituloDoc"
                >
                  <span>Descargar Archivo </span>
                </b-link>

                <h5 v-if="!urlTituloDoc" class="col-2">No hay archivo</h5>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.titulo"
                  :state="Boolean(uploads.titulo)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  accept=".pdf"
                />
              </div>

              <hr>

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Firma</h6>

                <b-link 
                  v-if="urlFirmaDoc"
                  class="text-primary col-2"
                  @click="onViewFile(urlFirmaDoc)"
                >
                  <span>Descargar Archivo</span>
                </b-link>

                <span v-if="!urlFirmaDoc" class="col-2">No hay archivo</span>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.firma"
                  :state="Boolean(uploads.firma)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  @change="validarArchivo($event, 'firma')"
                  accept=".png,.jpg,.jpeg"
                />
              </div>

              <hr>

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Firma y Sello</h6>
                
                <b-link
                  v-if="urlFirmaSelloDoc"
                  class="text-primary col-2"
                  @click="onViewFile(urlFirmaSelloDoc)" 
                >
                  <span>Descargar Archivo </span>
                </b-link>

                <span v-if="!urlFirmaSelloDoc" class="col-2">No hay archivo</span>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.sello"
                  :state="Boolean(uploads.sello)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  accept=".png,.jpg,.jpeg"
                  @change="validarArchivo($event, 'sello')"
                />
              </div>
              
            </b-card>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />
  
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { required } from '@validations'
import rutas from '@/assets/utils/rutas.json';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { BootstrapVue } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { fileService } from '@/shared/services';
import { ModalViewFile } from '@/shared/components';
import DoctorHorarioForm from './components/DoctorHorarioForm.vue';

const DAYS_ORDER = [
  { key: 'monday', value: 1 },
  { key: 'tuesday', value: 2 },
  { key: 'wednesday', value: 3 },
  { key: 'thursday', value: 4 },
  { key: 'friday', value: 5 },
  { key: 'saturday', value: 6 },
];

const getDefaultHorario = () => ({
  monday: { enabled: false, start: null, end: null },
  tuesday: { enabled: false, start: null, end: null },
  wednesday: { enabled: false, start: null, end: null },
  thursday: { enabled: false, start: null, end: null },
  friday: { enabled: false, start: null, end: null },
  saturday: { enabled: false, start: null, end: null },
});

const parseDayValue = (value) => {
  if (typeof value === 'number') return value;
  if (!value && value !== 0) return null;
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : null;
};

export default {
  components: {
    ...BootstrapVue.components,
    ModalViewFile,
    FormWizard,
    TabContent,       
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    DoctorHorarioForm,
    
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {

      errors: [],

      uploads:{
        titulo:null,
        firma:null,
        sello:null
      },
      horariosDoctor: getDefaultHorario(),
      turnoMinutos: 20,
      identificaciones:null,
      identificacionrepetida: false,
      fileToView:null,
      isModalFileVisible: false,

      urlTitulo:null,
      urlFirma:null,
      birthDateConfig: {
        allowInput: true
      },
      required,
      nombred:null,
      apellidod:null,
      numeroregistrosenescyt:null,
      fechaInicioDoctor:null,
      especialidad:null,
      tipodoctor:null,
      especialidadDescripcion:null,
      itemDoc:null,
      fechaNacimiento:'',
      urlTituloSenescyt:null,
      idPerDoc:null,
      idDoctor:null,
      urlFirmaDoc:null,
      urlFirmaSelloDoc:null,
      urlTituloDoc:null,

      filesDoctor: [
        {
          documento: "Titulo Sennecyt",
          url: null,
          upload: null
        },
        {
          documento: "Firma Doctor",
          url: null,
          upload:null
        },
        {
          documento: "Firma y Sello Doctor",
          url: null,
          upload:null
        }
      ],

      opsTipoIdent: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Passporte' }
      ],

      opsEspecialidad: [],
      opsTipoDoctor: [],
      tipoIdent:null,
      identificacion:'',
      celular:'',
      email:'',

    }
  },
  
  async created() {
    const tokenDoctor = this.$route.params.token;

    this.setToken();
    this.comprobarPermisos();

    await this.fetchEspecilidades();
    await this.fetchTipos();

    this.beforeStepChange();
    this.fetchViewUpdateDoctor(tokenDoctor);
  },

  computed: {
    identificacionRules() {
      // Reglas de validación dinámicas basadas en el tipo de identificación
      if (this.tipoIdent === '1') {
        return 'required|integer|digits:10';
      } else if (this.tipoIdent === '0') {
        return 'required|integer|digits:13';
      } else if (this.tipoIdent === '2') {
        return 'required'; // Para Pasaporte (números y letras)
      }
    },

    inputType() {
      if (this.tipoIdent === '2') {
        return 'text'; // Pasaporte
      } else {
        console.log("llega 3")
        return 'number'; // Cédula o RUC
      }
    },
    maxInputLength() {
      if (this.tipoIdent === '1') {
        return 10; // Cedula
      } else if (this.tipoIdent === '0') {
        return 13; // RUC
      } else {
        return 10; // Pasaporte
      }
      return null
    },

  },
    
  methods: {
    validarArchivo(event, target) {
      const archivo = event.target.files[0];
      if (!archivo) return;

      const tipoValido = ['image/png', 'image/jpg', 'image/jpeg'];
      if (!tipoValido.includes(archivo.type)) {
        if (target == 'firma') { this.uploads.firma = '' }
        if (target == 'sello') { this.uploads.sello = '' }
    
        
        this.$swal.fire({
          title:'Ups',
          icon:'error',
          text:'No se permiten archivos diferentes a jpg, png o jpeg',
          timer:15000
        })
      }
    },


    onViewFile(urlF) { 
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },
        
    
    beforeStepChange(newStep, oldStep, prevent) {
      // Aquí puedes realizar validaciones antes de cambiar de paso
      // Si quieres prevenir el cambio de paso en caso de no pasar la validación
      if (newStep > oldStep && !this.validateCurrentStep()) {
        prevent();
      }
    },
    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('adm_editar_doctor') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },
    showToastSuccess() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Doctor Editado',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },

    async fetchTipos() {
      const query = `
        query {
          allTipomedico {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsTipoDoctor = response.data.data.allTipomedico.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        
        console.error("Error fetching tipo doctor:", error.response.data);
      }
    },
    
    
    async fetchEspecilidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {

        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsEspecialidad = response.data.data.allEspecialidad.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
    validationFormInfo() {


      return new Promise((resolve, reject) => {

        if(this.identificacionrepetida){
          this.$swal({
            title: 'Cedula pertenece a otra persona',
            text: 'Por favor ingrese una cedula que no exista',
            icon: 'error',
            confirmButtonText: 'Entendido'
          })
          reject()
        }
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },

    validationFormDocu() {
      return new Promise((resolve, reject) => {
        this.$refs.docuRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },

    validationHorario() {
      const horarios = this.buildHorarioPayload();

      if (!horarios.length) {
        this.$swal({
          title: 'Horario incompleto',
          text: 'Seleccione al menos un día con horario válido.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      if (!this.turnoMinutos) {
        this.$swal({
          title: 'Duración de turnos',
          text: 'Seleccione la duración de los turnos.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      const invalidRange = horarios.some(h => !this.isTimeRangeValid(h.hora_inicio, h.hora_fin));
      if (invalidRange) {
        this.$swal({
          title: 'Horario inválido',
          text: 'Verifique que la hora de inicio sea menor que la hora de fin.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      return true;
    },

    buildHorarioPayload() {
      const horarios = [];
      DAYS_ORDER.forEach(day => {
        const data = this.horariosDoctor[day.key];
        if (!data || !data.enabled) return;
        if (!data.start || !data.end) return;

        horarios.push({
          dia: day.value,
          hora_inicio: data.start,
          hora_fin: data.end,
          duracion: Number(this.turnoMinutos),
        });
      });

      return horarios;
    },

    isTimeRangeValid(start, end) {
      if (!start || !end) return false;
      const [startH, startM] = start.split(':').map(Number);
      const [endH, endM] = end.split(':').map(Number);
      return (startH * 60 + startM) < (endH * 60 + endM);
    },

    async guardarHorarioDoctor(doctorId) {
      const horarios = this.buildHorarioPayload();
      const query = `
        mutation SetHorarioDoctor($doctorId: String!, $horarios: String!) {
          setHorarioDoctor(doctorId: $doctorId, horarios: $horarios) {
            status
            message
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables: {
            doctorId: String(doctorId),
            horarios: JSON.stringify(horarios),
          },
        });

        const payload = response.data.data?.setHorarioDoctor;
        if (!payload || payload.status !== 'success') {
          throw new Error(payload?.message || 'No fue posible guardar el horario del doctor');
        }

        return true;
      } catch (error) {
        console.error('Error al guardar horario del doctor:', error);
        this.$swal({
          title: 'Error',
          text: error.message || 'Error al guardar el horario del doctor',
          icon: 'error',
          confirmButtonColor: '#089599',
        });
        return false;
      }
    },


    async actualizarDoctor() {

      try {
        const argDoctorPersona = {
          nombres: this.nombred,
          apellidos: this.apellidod,
          ...(this.tipoIdent.value ?  {tipoIdent: this.tipoIdent.value } : { tipoIdent:''}),
          identificacion: this.identificacion,
          telefono: this.celular,
          email: this.email,
          sexo:'',
          urlIdentificacion:'',
          fechaNacimiento: this.fechaNacimiento,
          idPersona: this.idPersona,
          estadoCivil:'',
          nacionalidad: '',
          nivelEducacion: '',
          profesion: '',
          pueKichwa: '',
          tipoBono: '',
          nacioEtni: '',
          idbarrio: '', 
          cprincipal: '',
          csecundaria: '',
          referenciasect: '',
          esDiscapacitado: 0,
          urlCarnet: '',
          idPersona:this.idPerDoc
        };

        const responseUpdate = await this.actualizarPersona(argDoctorPersona);

        if (!responseUpdate) {
          return;
        }

        let urlTitulo = null;
        let urlFirma  = null;
        let urlSello  = null;

        if(this.uploads.titulo)
          urlTitulo = await fileService.upload('titulos', this.uploads.titulo, this.identificacion );

        if(this.uploads.firma)
          urlFirma  = await fileService.upload('firmas', this.uploads.firma, this.identificacion );

        if(this.uploads.sello)
          urlSello  = await fileService.upload('sellos', this.uploads.sello, this.identificacion );
        
        const argDoctor = {
          id: this.idDoctor,
          numeroregistrosenescyt:(this.numeroregistrosenescyt),
          fechaInicioDoctor: this.fechaInicioDoctor,
          ...(urlTitulo ? { urlTitulo: urlTitulo } : {}),
          ...(urlFirma  ? { urlFirma: urlFirma }   : {}),
          ...(urlSello  ? { urlSello: urlSello }   : {}),

          ...(this.especialidad.value ? { especialidad: this.especialidad.value } : { especialidad :''}),
          ...(this.tipodoctor.value ? { tipomedico: this.tipodoctor.value } : {tipodoctor:''}),
        };

        console.log('argDoctor', argDoctor);

        const response = await axios.post(rutas.axios + 'api', {
          query: `
            mutation editarDoctor (
              $id: String!,
              $numeroregistrosenescyt: String,
              $urlTitulo: String,
              $urlFirma: String,
              $urlSello: String,
              $especialidad: String,
              $tipomedico:String,
              $fechaInicioDoctor:String
            ){
              editarDoctor(
                id:$id
                numeroregistrosenescyt:$numeroregistrosenescyt
                urlTituloSenescyt:$urlTitulo
                urlP12FirmaElectronica: $urlFirma
                urlFirmaSello: $urlSello
                especialidad: $especialidad
                tipomedico: $tipomedico
                fechaInicioDoctor: $fechaInicioDoctor            
              ){
                doctor {
                  token,id
                }
                  status,
                  message
                }
            }
          `,

          variables: argDoctor

        });

        if (response.status === 200) {
          const payload = response.data.data.editarDoctor;
          if (payload.status === 'success') {
            const horarioActualizado = await this.guardarHorarioDoctor(this.idDoctor);
            if (!horarioActualizado) {
              throw new Error('No se pudo actualizar el horario del doctor');
            }

            this.$swal({
              title: 'Actualizado',
              text: 'El doctor ha sido actualizado',
              icon: 'success',
            });

            this.$router.push({ name: 'consultar_doctor' });
          } else {
            this.$swal({
              title: 'Error',
              text: payload.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
      } catch (err) {
        console.log('Error doctor update process:', err)
        this.$swal({
          title: 'Error',
          text: 'Error en actualizar doctor: ' + err,
          icon: 'error',
          confirmButtonColor: '#089599',
        })
      }
    },

    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) alert('form submitted!')
      })
    },
    async fetchPersonas(search) {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id  
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { search }
        });

        const personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        this.identificaciones = identificaciones
      
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    async actualizarPersona(argPersona) {
      try {
        const response = await axios.post(rutas.axios + 'api', {
          query: `
            mutation actualizarPersonaMut (
                $nombres: String!,
                $apellidos: String!,
                $tipoIdent: String!,
                $identificacion: String!,
                $sexo: String!,
                $fechaNacimiento: String!,
                $urlIdentificacion: String!,
                $estadoCivil:String!,
                $telefono:String!,
                $nacionalidad:String,
                $nivelEducacion:String,
                $email:String,
                $profesion:String,
                $pueKichwa:String,
                $tipoBono:String,
                $nacioEtni:String,
                $callePrincipal: String,
                $calleSecundaria: String,
                $referencia: String,
                $barrio: String,
                $idPersona: String!,
                $urlCarnet: String,
                $esDiscapacitado: Int,
            ){
              actualizarPersona(
                nombres:$nombres
                apellidos:$apellidos
                tipoIdent:$tipoIdent
                identificacion:$identificacion
                estadoCivil:$estadoCivil
                urlIdentificacion:$urlIdentificacion
                sexo:$sexo
                telefono:$telefono
                fechaNacimiento:$fechaNacimiento
                nacionalidad:$nacionalidad
                nivelEducacion:$nivelEducacion
                email: $email
                profesion:$profesion
                pueKichwa:$pueKichwa
                tipoBono:$tipoBono
                nacioEtni:$nacioEtni
                callePrincipal:$callePrincipal
                calleSecundaria:$calleSecundaria
                referencia:$referencia
                barrio:$barrio
                idPersona:$idPersona
                urlCarnet : $urlCarnet
                esDiscapacitado : $esDiscapacitado
              ){
                persona {
                  token,id
                }
                status,
                message
              }
            } 
          `,

          variables: argPersona
        });
        if (response.status === 200) {
          if (response.data.data.actualizarPersona.status === 'success') {

            const { token, id } = response.data.data.actualizarPersona.persona;
            if (id > 0)
              return id;
            else
              return 0;
          }
        }
      } catch (err) {
        console.log(err);
        return 0;
      }
    },
  
    async formSubmittedUpdateDoctor() {
      await this.actualizarDoctor();
    },


    async fetchViewUpdateDoctor(tokenDoctor) {
      const query = `
        query qrgetTokenDoctor($token: String!){
          getTokenDoctor(tokenDoctor: $token) {
            doctor {
              id
              numeroregistrosenescyt
              urlTituloSenescyt
              urlP12FirmaElectronica
              urlFirmaSello
              fechainiciodoctor
              tipomedico{
                id
                descripcion
              }
              idPersona {
                sexo
                id
                tipoIdentificacion
                fechaNacimiento
                identificacion
                correo
                primerNombre
                segundoNombre
                primerApellido
                segundoApellido
                telefono
              }
              especialidad{
                id
                descripcion
              }
              horarios {
                dia
                horaInicio
                horaFin
                duracionTurno
              }
            }
            status
            message
          }
        }

          `;
      const variables = {
        token: tokenDoctor,
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status === 200) {
          if (response.data.data.getTokenDoctor.status === 'success') {

            if (response.data.data.getTokenDoctor.doctor) {
              const item = response.data.data.getTokenDoctor.doctor;
              this.itemDoctor = {
                especialidadDescripcion: item.especialidad.descripcion,
                especialidad:item.especialidad,
                especialidadId:item.especialidad.id,
                identificacionDoc: item.idPersona.identificacion,
                nombreDoc: item.idPersona.primerNombre,
                idPerDoc:item.idPersona.id,
                apellidoDoc: item.idPersona.primerApellido,
                fechaNacimientoDoc: item.idPersona.fechaNacimiento,
                celularDoc: item.idPersona.telefono,
                email: item.idPersona.correo,
                idDoctor:item.id,
                numeroregistrosenescyt: item.numeroregistrosenescyt,
                tipoIdentificacionDoc: item.idPersona.tipoIdentificacion,
                urlFirmaD: item.urlP12FirmaElectronica,
                urlFirmaSelloD: item.urlFirmaSello,
                urlTituloD:item.urlTituloSenescyt,
                tipodoctor:item.tipomedico,
                fechaInicioDoctor:item.fechainiciodoctor,
              };
              
              if (this.itemDoctor) {
                this.nombred = this.itemDoctor.nombreDoc;
                this.especialidad = this.opsEspecialidad.find(e => e.value === this.itemDoctor.especialidadId);
                this.idPerDoc=this.itemDoctor.idPerDoc;
                this.apellidod = this.itemDoctor.apellidoDoc;
                this.numeroregistrosenescyt=this.itemDoctor.numeroregistrosenescyt;
                this.fechaNacimiento = this.itemDoctor.fechaNacimientoDoc;
                this.tipoIdent = this.itemDoctor.tipoIdentificacionDoc;
                this.celular = this.itemDoctor.celularDoc;
                this.identificacion = this.itemDoctor.identificacionDoc;
                this.email=this.itemDoctor.email;
                this.urlFirmaDoc = this.itemDoctor.urlFirmaD;
                this.urlFirmaSelloDoc = this.itemDoctor.urlFirmaSelloD;
                this.urlTituloDoc = this.itemDoctor.urlTituloD;
                this.tipodoctor = this.opsTipoDoctor.find(e => e.value === this.itemDoctor.tipodoctor.id);
                this.fechaInicioDoctor= this.itemDoctor.fechaInicioDoctor; 
                this.idDoctor=this.itemDoctor.idDoctor

                const horarioMapa = getDefaultHorario();
                const horarios = item.horarios || [];
                if (horarios.length) {
                  this.turnoMinutos = Number(horarios[0].duracionTurno) || 20;
                }

                horarios.forEach(horario => {
                  const dayValue = parseDayValue(horario.dia);
                  const day = DAYS_ORDER.find(dayItem => dayItem.value === dayValue);
                  if (!day) return;
                  horarioMapa[day.key] = {
                    enabled: true,
                    start: (horario.horaInicio || '').substring(0, 5),
                    end: (horario.horaFin || '').substring(0, 5),
                  };
                });

                this.horariosDoctor = horarioMapa;
              } 
              
            }
          }
        }
      } catch (error) {
        console.error("Error fetching doctor:", error);
      }
    },

    async encontrarPersona(search = '', contactPaciente = false) {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id
            fechaNacimiento
            sexo
            segundoApellido
            segundoNombre
            tipoIdentificacion
            estadoCivil
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { search }
        });

        if (contactPaciente) {
          const persona = response.data.data.allPersona[0]
          this.identificacionCont = persona.identificacion
        }

        const personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        return response.data.data.allPersona[0]

      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

  
  },
  watch:
  {
    especialidadDescripcion(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.especialidad = this.opsEspecialidad.find(e => e.descripcion === newVal);
        this.especialidadId = this.especialidad.id;
      }
    },
    tipoDescripcion(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tipo = this.opsTipoDoctor.find(e => e.descripcion === newVal);
        this.tipoId = this.tipo.id;
      }
    },

    uploads: {
      deep: true,
      handler(newValue){
        console.log(newValue)
      }
    },

    tipoIdent(newTipoIdent) {
      this.tipoIdentValidation = null;
      this.tipoIdentErrors = [];
      this.identificacionValidation = null;
      this.identificacionErrors = [];
    },
  }
}
</script>
<style>
.my-icon-link {
  margin-right: 10px;
  padding-left: 500px;
}
.flatpickr-container input {
    padding: 0.438rem 1rem;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    display: block;
    width: 100%;
    height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
